<template>
  <div :style="{ width: '100%', height: '100%', borderRadius: '4px' }" class="calendar-box">
    <div class="title">{{ title }}</div>
    <div class="canlendar-top-box">
      <div class="canlendar-top">
        <a-date-picker
          v-model:value="selectValue"
          :allowClear="false"
          v-if="selectType"
          @change="handleWeekChange(selectValue)"
          picker="month"
        />
        <a-date-picker v-model:value="selectValue" :allowClear="false" v-if="!selectType" picker="week" />

        <a-radio-group v-model:value="selectType" style="margin-left: 20px" @change="handleWeekChange(selectValue)">
          <a-radio-button :value="false">{{ dateObj.week }}</a-radio-button>
          <a-radio-button :value="true">{{ dateObj.month }}</a-radio-button>
        </a-radio-group>
      </div>
      <SelectTime @changeNowDate="changeNowDate" :date="selectValue" :selectType="selectType"></SelectTime>
    </div>
    <a-calendar v-model:value="selectValue" :fullscreen="false" v-show="selectType">
      <template #headerRender> </template>
      <template #dateCellRender="{ current: dayjs }">
        <div v-if="haveMsg(dayjs)" class="haveDate">
          <a-tooltip placement="topRight" trigger="click" color="rgba(19, 32, 67, 0.9)">
            <template #title>
              <p>{{ dateObj.date }}：{{ fromDateGetData(dayjs).date }}</p>
              <div v-for="item in fromDateGetData(dayjs).list" :key="item.id" style="padding: 10px">
                <p>{{ dateObj.pvxrjv }}：<a href="javascript:;" @click="handleVisitPlan(item.id)" style="text-decoration: underline;">{{ item.title || '--' }}</a></p>
                <p>{{ dateObj.rqp3ld }}：{{ item.customerName || '--' }}</p>
                <p>{{ dateObj.agy27l }}：{{ item.contactName || '--' }}</p>
                <p>{{ dateObj.rzzoit }}：{{ item.startTime || '--' }}</p>
                <p>{{ dateObj.ld71ju }}：{{ item.mode || '--' }}</p>
                <p>{{ dateObj['5afs7f'] }}：{{ item.purpose || '--' }}</p>
              </div>
            </template>
            <div>
              {{ setData(dayjs) }}
            </div>
          </a-tooltip>
        </div>
      </template>
    </a-calendar>
    <WeekCalendar :selectValue="week" v-show="!selectType" :allData="dateOption"></WeekCalendar>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, watch, computed } from 'vue'
import WeekCalendar from '@/components/WeekCalendar/index.vue'
import SelectTime from './components/SelectTime.vue'
import dayjs, { Dayjs } from 'dayjs'
import { toBeijingTime } from '@/utils/timeFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { getHomePageVisitPlan } from '@/api/gucangSales/index'
import { getHomePageVisitPlanYT } from '@/api/yuntuSales/index'
import { getHomePageVisitPlanOfbu } from '@/api/overseasSales/index'
import { useI18n } from 'vue-i18n'
import { useInteractionStore } from '@/stores/interaction'
import type { HomePageVisitPlan } from '@/typings/api/index'
import { useRouter } from 'vue-router'
export default defineComponent({
  components: {
    WeekCalendar,
    SelectTime
  },
  props: {
    appId: {
      type: String,
      default: 'fbu' // fbu/lbu/ofbu
    },
    // 是否需要支持多语言
    isMultiLanguage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { t } = useI18n()
    const router = useRouter()
    dayjs.extend(advancedFormat)
    const value = ref()
    const selectType = ref(true)
    const title = computed(() => {
      return props.isMultiLanguage ? t('common.calendar') : '日历'
    })
    const dateObj = computed(() => {
      if (props.isMultiLanguage) {
        return {
          date: t('common.date'),
          month: t('common.month'),
          week: t('common.week'),
          pvxrjv: t('home.pvxrjv'),
          rqp3ld: t('home.rqp3ld'),
          agy27l: t('home.agy27l'),
          rzzoit: t('home.rzzoit'),
          ld71ju: t('home.ld71ju'),
          '5afs7f': t('home.5afs7f')
        }
      } else {
        return {
          date: '日期',
          month: '月',
          week: '周',
          pvxrjv: '计划标题',
          rqp3ld: '客户名称',
          agy27l: '联系人',
          rzzoit: '计划拜访时间',
          ld71ju: '拜访方式',
          '5afs7f': '拜访目的'
        }
      }
    })

    const dateOption = ref<any>([])
    const haveMsg = (str: string) => {
      const data = dayjs(str).format('YYYY/MM/DD')
      const index = dateOption.value?.findIndex((item: HomePageVisitPlan) => {
        return item.date === data
      })
      if (index === -1) {
        return false
      } else {
        return true
      }
    }
    const fromDateGetData = (str: string) => {
      const index = dateOption.value?.findIndex((item: HomePageVisitPlan) => {
        return item.date === dayjs(str).format('YYYY/MM/DD')
      })
      if (index === -1) {
        return false
      } else {
        return dateOption.value[index]
      }
    }
    const AppIDType = ref('fbu')
    watch(
      props,
      () => {
        AppIDType.value = props.appId
      },
      { immediate: true }
    )
    const selectValue = ref<Dayjs>(dayjs())
    const calendarValue = ref<Dayjs>(dayjs())
    const getData = async () => {
      try {
        let res
        const start = dayjs(selectValue.value).startOf('month').format('YYYY/MM/DD HH:mm:ss')
        const end = dayjs(selectValue.value).endOf('month').format('YYYY/MM/DD HH:mm:ss')
        if (AppIDType.value === 'fbu') {
          res = await getHomePageVisitPlan({
            startTime: start,
            endTime: end
          })
        } else if (AppIDType.value === 'ofbu') {
          res = await getHomePageVisitPlanOfbu({
            startTime: toBeijingTime(start),
            endTime: toBeijingTime(end)
          })
        } else {
          res = await getHomePageVisitPlanYT({
            startTime: start,
            endTime: end
          })
        }

        if (res.data) {
          dateOption.value = res.data
        }
      } catch (error) {
        console.log('getData error: ', error)
      }
    }
    const shareInfo = useInteractionStore()
    watch(shareInfo, (newValue) => {
      selectValue.value = dayjs(selectValue.value).locale(newValue.language)
    })
    watch(selectValue, (newValue) => {
      getData()
      handleWeekChange(newValue)
    })
    const week = ref()
    const handleWeekChange = (weekData: Dayjs) => {
      const arr = [1, 2, 3, 4, 5, 6, 7]
      week.value = []
      const firstDay = dayjs(weekData).startOf('week')
      arr.forEach((item, index) => {
        week.value.push(dayjs(firstDay).add(index, 'day').format('YYYY/MM/DD'))
      })
    }
    const handleVisitPlan = (id: string) => {
      router.push({
        path: '/lbu/visitorProgram/view',
        query: {
          id
        }
      })
    }
    const changeNowDate = (value: Dayjs) => {
      selectValue.value = value
    }
    const setData = (day: Dayjs) => {
      return dayjs(day).format('DD')
    }
    onMounted(() => {
      handleWeekChange(dayjs())
      getData()
    })
    return {
      t,
      title,
      dateObj,
      value,
      dateOption,
      haveMsg,
      selectType,
      type: ref<any>('month'),
      selectValue,
      handleWeekChange,
      changeNowDate,
      week,
      setData,
      calendarValue,
      fromDateGetData,
      handleVisitPlan
    }
  }
})
</script>
<style lang="scss" scoped>
:deep(.ant-popover-inner) {
  background-color: rgba(19, 32, 67, 0.9) !important;
}
:deep(.ant-picker-calendar-header) {
  padding: 45px;
}

:deep(.ant-picker-month-panel .ant-picker-cell-inner) {
  padding: 0px !important;
}
.calendar-box {
  position: relative;
  .canlendar-top-box {
    height: 140px;
  }
  .canlendar-top-box {
    padding: 20px 0px 0 0;
    display: flex;
    justify-content: center;

    .canlendar-top {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 20px;
    }
  }
  .title {
    position: absolute;
    top: 23px;
    left: 24px;
    font-size: 16px;
    color: #666666;
    font-weight: 500;
  }
}
.haveDate {
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid #1d4cd2;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  position: absolute;
  top: 0px;
  z-index: 999;
}
:deep(.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before) {
  display: none;
}
:deep(.ant-picker-cell-today) {
  color: #1d4cd2 !important;
}
:deep(.ant-picker-cell-selected .ant-picker-calendar-date-value) {
  border-radius: 4px;
}
:deep(.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner) {
  background: rgba(29, 76, 210, 0.2) !important;
  color: #666666;
}
:deep(.ant-picker-cell-today .ant-picker-cell-inner) {
  color: #1d4cd2 !important;
}
:deep(.ant-picker-calendar-date-today) {
  color: #1d4cd2 !important;
}
:deep(.ant-picker-cell-selected .haveDate) {
  background: rgba(29, 76, 210, 0.1) !important;
}
:deep(.ant-picker-calendar-date-today .haveDate) {
  color: #1d4cd2;
}
</style>
